import { render, staticRenderFns } from "./HelloForm.vue?vue&type=template&id=2634b56d&"
import script from "./HelloForm.vue?vue&type=script&lang=js&"
export * from "./HelloForm.vue?vue&type=script&lang=js&"
import style0 from "./HelloForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports